module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-09-04 at 22.30.19.6331c833.jpeg";